import { useState, useEffect } from 'preact/hooks';
import PropTypes from 'prop-types';
import { Accordion } from '../../Global/Accordion';
import Text from '../../Global/Text';
import { actionHandler } from '../../../utilities/form/formUtils';
import Icon from '../../Global/Icon';
import { updateInsuranceAction } from '../../../actions/UserData';
import Label from '../../Form/Label';
import { getCoverageDescription } from '../../../utilities/coverage/descriptionUtils';
import { getCoverageTitle } from '../../../utilities/coverage/titleUtils';
import BackButton from '../../Global/BackButton';
import { getProductPrice, getCoveragePrice } from '../../../utilities/combined-common';

export const CombinedAccordion = (props) => {
  const { components, priceDetails, priceTitle, basketList, actions, dispatch,
    userData, initialValues, titlePre, titlePost, priceBreakActions, currentProgress,
    buttonTitle, setValues, values, combinedPrice, commonFees, bsFees } = props;

  const { coverageList } = initialValues || {};
  const filteredComponents = components.filter(item => basketList.includes(item.name));
  const [totalPrice, setTotalPrice] = useState(0);
  const [clickCount, setClickCount] = useState(0);
  const [activeSwitches, setActiveSwitches] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [indexNum, setIndexNum] = useState(0);
  const [hasBeenExpanded, setHasBeenExpanded] = useState(Array(filteredComponents.length).fill(false));
  const [isLoading, setIsLoading] = useState(false);
  const [indexVal, setIndexVal] = useState(0);
  let totalcostIndex = userData.initialCost;
  const getPrice = (product) => {
    let price = getProductPrice(product, userData);
    return price;
  }

  const selectItems = components.reduce((accum, item) => {
    const selects = item.additionalCoverage.filter(coverage => coverage.type === 'selectOption');
    return accum.concat(selects);
  }, []);
  // update the active switches
  const updateTotalPrice = (index, coverageIndex) => {
    setActiveSwitches((prevActiveSwitches) => {
      const updatedSwitches = [...prevActiveSwitches];
      if (updatedSwitches[index] === undefined) {
        updatedSwitches[index] = [];
      }
      if (updatedSwitches[index].includes(coverageIndex)) {
        updatedSwitches[index] = updatedSwitches[index].filter((item) => item !== coverageIndex);
      } else {
        updatedSwitches[index] = [...updatedSwitches[index], coverageIndex];
      }
      return updatedSwitches;
    });
  };

  //to calculate total price for a specific index
  const calculateTotalPriceForIndex = (index) => {
    let calculatedTotalPrice = 0;
    const item = filteredComponents[index];
    const activeCoverage = activeSwitches[index] || [];
    activeCoverage.forEach((coverageIndex) => {
      const currentItem = item.additionalCoverage[coverageIndex];
      if(currentItem.coveragePrice){
        const getAdditionalPrice = getCoveragePrice(currentItem.coveragePrice, userData)
        calculatedTotalPrice += getAdditionalPrice;
      }
      else 
        calculatedTotalPrice += currentItem.price;
    });
    return calculatedTotalPrice;
  };
  totalcostIndex = totalPrice + userData.initialCost;
  const handleNextClick = async () => {
    setIsLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setClickCount(indexVal + 1);
    
    dispatch(updateInsuranceAction({ totalCost: totalcostIndex, activeSwitches: activeSwitches, hasBeenExpanded: hasBeenExpanded }));
    setIsLoading(false);
  };

  const handleClick = async (e) => {
    try {
      await handleNextClick();
      if (!isLoading) {
        if (indexVal === filteredComponents.length - 1) {
          await actionHandler(actions, null, null, dispatch, userData, setValues);
        }
      }
    } catch (error) {
      console.error('An error occurred during handleClick:', error);
      setIsLoading(false);
    }

  };

  const handleAccordionExpand = (item, index) => {
    setIndexVal(index);
    const newHasBeenExpanded = [...hasBeenExpanded];
    newHasBeenExpanded[index] = true;
    setHasBeenExpanded(newHasBeenExpanded);

    for(const element of components){
      if(item === element.name){
        setSelectedItem(element.label);
      }
    }
  };
  const handleClickIcon = (data) => {
    // Checking if data is an object and has a 'package' property
    let modalActions = [];
    const title = !data.displayName ? getCoverageTitle({}, coverageList, {}, "", data.package, true)
      : data.displayName;
    if (typeof data === 'object' && data.package) {
      const desc = getCoverageDescription({}, coverageList, {}, "", data.package, userData, null);
      modalActions = [
        {
          actionType: 'modal',
          props: {
            title: title,
            body: desc
          }
        },
      ];
    }
    else if (typeof data === 'string') {
      modalActions = [
        {
          actionType: 'modal',
          props: {
            name: `${selectedItem.toLowerCase()}CoverageInfoIcon`,
            title: data,
          }
        },
      ];
    }
    else {
      modalActions = [
        {
          actionType: 'modal',
          props: {
            title: data.displayName,
            body: data.desc
          }
        },
      ];
    }
    actionHandler(modalActions, null, 'title', dispatch);
  };
  useEffect(() => {
    // Update activeSwitches when userData.activeSwitches changes
    setActiveSwitches(userData.activeSwitches || []);
    setHasBeenExpanded(userData.hasBeenExpanded || []);
  }, [userData.activeSwitches, userData.hasBeenExpanded]);

  useEffect(() => {
    // Calculate the total price as per active switches index
    let calculatedTotalPrice = 0;
    filteredComponents.forEach((item, index) => {
      const activeCoverage = activeSwitches[index] || [];
      activeCoverage.forEach((coverageIndex) => {
        const currentItem = item.additionalCoverage[coverageIndex];
         if(currentItem.coveragePrice){
          const getAdditionalPrice = getCoveragePrice(currentItem.coveragePrice, userData)
          calculatedTotalPrice += getAdditionalPrice;
        }
        else 
          calculatedTotalPrice += currentItem.price;
      });
    });

    // Update the total price with the calculatedTotalPrice
    setTotalPrice(calculatedTotalPrice);
  }, [activeSwitches, filteredComponents]);

  const toggleIndex = (index) => {
    if (indexNum === index) {
      setIndexNum(null);
    } else {
      setIndexNum(index);
    }
  };

  return (
    <>
      <div>
        <div className='accordion_page_title'>
          <div className='accordion_page_title_pre'>
            <Text value={titlePre} />
          </div>
          {selectedItem}
          <div>
            <Text value={titlePost} />
          </div>
        </div>
        {filteredComponents.map((item, index) => (
          <div className='combined_accordion_main' key={item.name}>
            {/* Accordion component with props */}
            <Accordion
                initialValues={initialValues}
                content={item.name}
                item={item}
                index={index}
                price={`${getPrice(item.name) + calculateTotalPriceForIndex(index)} `}
                selectTitle={item.selectTitle}
                additionalCoverage={item.additionalCoverage}
                updateTotalPrice={updateTotalPrice}
                dispatch={dispatch}
                userData={userData}
                clickCount={clickCount}
                activeSwitches={activeSwitches[index] || []}
                hasBeenExpanded={hasBeenExpanded[index]}
                onExpand={() => handleAccordionExpand(item.name, index)}
                indexNum={indexNum}
                toggleIndex={() => toggleIndex(index)}
                isExpanded={indexNum === index}
                selectItems={selectItems}
                onClickIcon={handleClickIcon}
                values={values}
              />
          </div>
        ))}
      </div>
      <div className="price_footer_border"></div>
      <div>
        {/* Footer with text and button details */}
        <div className='combined_accordion_footer'>
          {combinedPrice &&
            <div className="actualPrice_footer_text">
              <div><Text className="actualPrice_footer_details" value={commonFees} /></div>
              <div className="actualPrice_price_text">{bsFees} <Text value="$[units.$[paymentFrequency]]" /></div>
            </div>
          }
          <div className="totalprice_footer_text">
            <div><Text className="totalcost_footer_details" value={priceTitle} /></div>
            <div className="footer_price_text">{}
            {combinedPrice ? Math.round(totalcostIndex + 9.5): Math.round(totalcostIndex)}
              <Text value="$[units.$[paymentFrequency]]" />
            </div>
          </div>
          <div>
            <Label
              className="footer_button_main"
              actions={priceBreakActions}
              dispatch={dispatch}
              label={priceDetails} />
          </div>
        </div>
      </div>
      {/* handleNextClick content */}
      <div className={"NavigationContainer"}>
        {currentProgress && !currentProgress.hideBackButton &&
          <BackButton
            className="button NavigationContainerBackButton"
            dispatch={dispatch}
            config={currentProgress?.backButtonConfig}
          />
        }
        <button
          type="button"
          className="tealiumSubmit form-submit form-submit--primary button button--primary"
          onClick={() => {
            handleClick();
            setIndexVal(indexNum);
          }}
        >
          <span>
            <Text value={buttonTitle} />
            <Icon class="icon icon--chevronLeft icon--fill-white" icon="chevronLeft" fill="red" />
          </span>
        </button>
      </div>
    </>
  );
};

CombinedAccordion.defaultProps = {
  priceDetails: "",
  priceTitle: "",
  initialValues: {},
  titlePre: "",
  titlePost: "",
  buttonTitle: "",
  combinedPrice: false,
  commonFees: "",
  bsFees: ""
}

CombinedAccordion.propTypes = {
  dispatch: PropTypes.func.isRequired,
  userData: PropTypes.object.isRequired,
  priceDetails: PropTypes.string,
  priceTitle: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  priceBreakActions: PropTypes.array.isRequired,
  currentProgress: PropTypes.object.isRequired,
  components: PropTypes.array.isRequired,
  basketList: PropTypes.array.isRequired,
  actions: PropTypes.array.isRequired,
  initialValues: PropTypes.object,
  titlePre: PropTypes.string,
  titlePost: PropTypes.string,
  buttonTitle: PropTypes.string,
  values: PropTypes.object.isRequired,
  combinedPrice: PropTypes.bool,
  commonFees: PropTypes.string,
  bsFees: PropTypes.string
}